import * as React from 'react';

import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { IconWarning } from '@lightspeed/flame/Icon/Warning';
import { Text } from '@lightspeed/flame/Text';
import { Tooltip } from '@lightspeed/flame/Tooltip';

import { createReactRenderer } from 'helpers/react-renderer';

export const StyledBox = styled(Box)`
  display: inline-block;
  margin-top: 0;
  > div {
    z-index: 100;
  }

  span {
    padding: 0 !important;
  }
`;
interface Props {
  costsModifiedAfterShipment: boolean;
  hasShipments: boolean;
}

const CostOrderTotal: React.FC<Props> = ({ hasShipments, costsModifiedAfterShipment }) => {
  const message =
    'Modification of shipping cost or discount was made after receiving shipments. There is a discrepancy in your ordered total.';

  return hasShipments && costsModifiedAfterShipment ? (
    <StyledBox>
      <Tooltip
        placement="top-start"
        // @ts-ignore
        content={
          <div style={{ maxWidth: 250 }}>
            <Text fontSize="12px" fontWeight="normal" lineHeight="1rem">
              {message}
            </Text>
          </div>
        }
      >
        <Box as="div" style={{ padding: '0 0 5px 8px' }}>
          <IconWarning size="16px" />
        </Box>
      </Tooltip>
    </StyledBox>
  ) : null;
};

const RenderedComponent = createReactRenderer({
  component: CostOrderTotal,
  selector: '[data-react-root="CostOrderTotal"]',
});

export default CostOrderTotal;

history.onChangeState(
  [
    {
      name: 'purchase.views.purchase',
      form_name: 'view',
      tab: 'main',
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
